//
export default {
  methods: {
    /**
     * 
     */
    click(item) {
      if (this.link(item) !== '') {
        return this.$router.push(this.link(item))
      }
    },
  },
  props: {
    /**
     * 
     */
    link: {
      type: Function,
      default: item => '',
    },
    /**
     * 
     */
    value: {
      type: Array,
      default: () => ([]),
    },
  },
}